import {
  CHAT_PANEL_CLOSE,
  CHAT_PANEL_TOGGLE,
  TREASURE_PANEL_CLOSE,
  TREASURE_PANEL_TOGGLE,
  LEADERBOARD_PANEL_CLOSE,
  LEADERBOARD_PANEL_TOGGLE,
} from '../types';

export function toggleLeaderboard() {
  return {type: LEADERBOARD_PANEL_TOGGLE};
}

export function hideLeaderboard() {
  return {type: LEADERBOARD_PANEL_CLOSE};
}

export function toggleTreasureChest() {
  return {type: TREASURE_PANEL_TOGGLE};
}

export function hideTreasureChest() {
  return {type: TREASURE_PANEL_CLOSE};
}

export function toggleChatPanel() {
  return {type: CHAT_PANEL_TOGGLE};
}

export function hideChatPanel() {
  return {type: CHAT_PANEL_CLOSE};
}
